import styled from 'styled-components'
import { theme } from '../styles/GlobalStyle'

const FiguresStyle = styled.div`
  padding-top: 7.3vw;

  .gradient {
    background-color: ${theme.grey};
  }

  .gradient figure {
    flex-direction: row-reverse;
  }

  h2 {
    font-size: 32px;
    font-weight: 300;
    line-height: 2;
    letter-spacing: normal;
    color: ${theme.slateDark};
  }

  figure {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 6.3vw 0;
  }

  figcaption {
    max-width: 340px;
  }

  figcaption > p {
    opacity: 0.5;
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: 0.5px;
    color: black;
  }

  @media (max-width: 767px) {
    figcaption {
      text-align: center;
    }

    figure:nth-child(1),
    figure:nth-child(3) {
      flex-direction: column;
    }

    figure > img {
      padding-top: 7.3vw;
      width: 50.3vw;
    }
  }

  @media (max-width: 1440px) {
    padding-top: 9.3vw;
  }

  @media (max-width: 992px) {
    padding-top: 12.3vw;
  }

  @media (max-width: 767px) {
    padding-top: 15.3vw;
  }

  @media (max-width: 640px) {
    padding-top: 20.3vw;
  }

  @media (max-width: 600px) {
    padding-top: 30.3vw;
  }
`
export default FiguresStyle
